import axios from '../../../configs/axios';
import { initParams } from '../configs';

const { store, id } = initParams;
const baseUrl = `/publishers/${store}/${id}`;

let pageDataController = null;
let appsController = null;

export const fetchPageDataRequest = (params) => {
  if (pageDataController) pageDataController.abort();
  if (appsController) appsController.abort();

  pageDataController = new AbortController();

  return axios
    .get(`${baseUrl}.json`, { params, signal: pageDataController.signal })
    .then((response) => response.data);
};

export const fetchAppsRequest = (params) => {
  if (appsController) appsController.abort();

  appsController = new AbortController();

  return axios
    .get(`${baseUrl}/apps.json`, { params, signal: appsController.signal })
    .then((response) => response.data);
};
